import { BsFillChatDotsFill } from 'react-icons/bs'
import { ombudsmanTranslate } from '../../../../i18n/translatedMessages'

import './ombudsman.sass'

const Ombudsman = () => (
	<div className='row'>
		<div className='col d-flex justify-content-center offset-1'>
			{/* <div className="empty">
                <BsFillChatDotsFill size={145} />
                <h4>{ombudsmanTranslate.noOccurrences}</h4>
            </div> */}
			<div className='container ombudsman-main'>
				<h3 className='fw-bold tw-mb-4'>Ombudsman</h3>
				<div className='row mt-4 justify-content-center'>
					<div className='col-md-12'>
						<div className='tw-text-lg tw-pr-20'>{ombudsmanTranslate.ombudmanTextOne}</div>
						<div className='tw-text-lg tw-mb-4 tw-pr-20'>{ombudsmanTranslate.ombudmanTextTwo}</div>
					</div>
					<div className='col-md-4 mt-3'>
						<a href='mailto:delivery@mydnadigital.com'>{ombudsmanTranslate.ombudsmanBtn}</a>
					</div>
				</div>
			</div>
		</div>
	</div>
)
export default Ombudsman
